import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onMounted, getCurrentInstance } from 'vue';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { useChemicanUrls } from '@/composables/useChemicanUrls';


export default /*#__PURE__*/_defineComponent({
  __name: 'LPFooter',
  setup(__props) {

const m = defineMessages({
  aboutChemican1: '化学物質管理の第一歩はSDS管理から、',
  aboutChemican2: 'ケミカンならSDSを正確にデータ化できます',
  about: 'ケミカンとは',
  pricing: '料金',
  downloadMaterials: '資料ダウンロード',
  copyright: 'Chemican, Inc. All Rights Reserved',
});

const isNotTop = ref(false);
const { proxy } = getCurrentInstance();

const updateIsNotTop = () => {
  isNotTop.value =
    proxy.$route.path !== '/' && proxy.$route.path !== '/corporate';
};

// 共通の URL 生成ロジックを使用
const {
  signupUrl,
  contactUrl,
  documentUrl,
  pricingUrl,
  aboutUrl,
  featuresUrl,
  companyUrl,
} = useChemicanUrls();

watch(() => proxy.$route.path, updateIsNotTop);

onMounted(updateIsNotTop);

return { __sfc: true,m, isNotTop, proxy, updateIsNotTop, signupUrl, contactUrl, documentUrl, pricingUrl, aboutUrl, featuresUrl, companyUrl, sharedMessages }
}

})